// extracted by css-extract-rspack-plugin
export default {"container":"AofZJscW0joijYrk"};